export const mockProducts = [
  // 어구류 - 그물
  {
    id: 'p001',
    name: '고강도 나일론 트롤 그물',
    category: 'fishing-gear',
    subcategory: '그물',
    manufacturer: '보령해양어구',
    region: 'boryeong',
    price: 3500000,
    unit: '세트',
    image: 'https://public.readdy.ai/ai/img_res/5dd1312f8f9ef8cacc869c3fa025922e.jpg',
    description: '내구성이 뛰어난 고강도 나일론 소재로 제작된 트롤 그물입니다. 대형 어선용으로 최적화되어 있으며, 우수한 인장강도를 자랑합니다.',
    specs: ['소재: 나일론 210D', '크기: 50m x 30m', '망목: 120mm', '인장강도: 500kg'],
    inStock: true,
    rating: 4.8,
    reviews: 24,
  },
  {
    id: 'p002',
    name: 'PE 자망 그물 (연근해용)',
    category: 'fishing-gear',
    subcategory: '그물',
    manufacturer: '목포수산자재',
    region: 'mokpo',
    price: 1200000,
    unit: '롤',
    image: 'https://readdy.ai/api/search-image?query=polyethylene-gillnet-fishing-net-coastal-fishing-equipment-white-background-product-shot-fine-mesh-pattern-lightweight-commercial-fishing-gear-professional-quality&width=800&height=600&seq=prod002&orientation=landscape',
    description: '연근해 어업에 최적화된 PE 자망 그물입니다. 가볍고 내구성이 우수하며, 다양한 어종 포획에 효과적입니다.',
    specs: ['소재: PE 섬유', '크기: 100m x 5m', '망목: 80mm', '무게: 45kg'],
    inStock: true,
    rating: 4.6,
    reviews: 18,
  },

  // 어구류 - 로프
  {
    id: 'p003',
    name: '3연 폴리프로필렌 로프 (20mm)',
    category: 'fishing-gear',
    subcategory: '로프',
    manufacturer: '부산해양로프',
    region: 'busan',
    price: 85000,
    unit: '100m',
    image: 'https://readdy.ai/api/search-image?query=three-strand-polypropylene-marine-rope-20mm-diameter-coiled-white-background-product-photography-durable-twisted-fiber-nautical-equipment-professional-grade-blue-color&width=800&height=600&seq=prod003&orientation=landscape',
    description: '내구성과 유연성이 뛰어난 3연 폴리프로필렌 로프입니다. 해수에 강하며 다양한 용도로 사용 가능합니다.',
    specs: ['직경: 20mm', '길이: 100m', '파단하중: 2,800kg', '소재: PP'],
    inStock: true,
    rating: 4.9,
    reviews: 42,
  },
  {
    id: 'p004',
    name: '나일론 계선 로프 (32mm)',
    category: 'fishing-gear',
    subcategory: '로프',
    manufacturer: '통영해양산업',
    region: 'tongyeong',
    price: 180000,
    unit: '100m',
    image: 'https://readdy.ai/api/search-image?query=heavy-duty-nylon-mooring-rope-32mm-thick-marine-grade-coiled-white-background-product-shot-strong-twisted-fiber-ship-docking-equipment-professional-quality&width=800&height=600&seq=prod004&orientation=landscape',
    description: '대형 선박 계선용 고강도 나일론 로프입니다. 충격 흡수력이 우수하고 내구성이 뛰어납니다.',
    specs: ['직경: 32mm', '길이: 100m', '파단하중: 8,500kg', '소재: 나일론'],
    inStock: true,
    rating: 4.7,
    reviews: 31,
  },

  // 갑판용품 - Wire
  {
    id: 'p005',
    name: '스테인리스 와이어 로프 (12mm)',
    category: 'deck-equipment',
    subcategory: 'Wire',
    manufacturer: '포항철강해양',
    region: 'pohang',
    price: 320000,
    unit: '100m',
    image: 'https://readdy.ai/api/search-image?query=stainless-steel-wire-rope-12mm-diameter-coiled-marine-grade-cable-white-background-product-photography-shiny-metal-twisted-strands-corrosion-resistant-industrial-quality&width=800&height=600&seq=prod005&orientation=landscape',
    description: '316 스테인리스 스틸 소재의 고품질 와이어 로프입니다. 부식에 강하고 장기간 사용 가능합니다.',
    specs: ['직경: 12mm', '길이: 100m', '파단하중: 9,800kg', '소재: SUS316'],
    inStock: true,
    rating: 4.9,
    reviews: 38,
  },
  {
    id: 'p006',
    name: '아연도금 와이어 로프 (16mm)',
    category: 'deck-equipment',
    subcategory: 'Wire',
    manufacturer: '부산철강',
    region: 'busan',
    price: 240000,
    unit: '100m',
    image: 'https://readdy.ai/api/search-image?query=galvanized-steel-wire-rope-16mm-thick-coiled-cable-white-background-product-shot-zinc-coated-metal-strands-heavy-duty-marine-equipment-industrial-grade&width=800&height=600&seq=prod006&orientation=landscape',
    description: '아연도금 처리된 고강도 와이어 로프입니다. 경제적이면서도 우수한 내구성을 제공합니다.',
    specs: ['직경: 16mm', '길이: 100m', '파단하중: 15,200kg', '소재: 아연도금강'],
    inStock: true,
    rating: 4.6,
    reviews: 29,
  },

  // 갑판용품 - Block
  {
    id: 'p007',
    name: '대형 스테인리스 블록 (5톤)',
    category: 'deck-equipment',
    subcategory: 'Block',
    manufacturer: '여수해양기계',
    region: 'yeosu',
    price: 580000,
    unit: '개',
    image: 'https://readdy.ai/api/search-image?query=large-stainless-steel-marine-pulley-block-5-ton-capacity-white-background-product-photography-heavy-duty-sheave-wheel-nautical-rigging-equipment-professional-grade-shiny-metal&width=800&height=600&seq=prod007&orientation=landscape',
    description: '5톤 하중을 견딜 수 있는 대형 스테인리스 블록입니다. 베어링 방식으로 회전이 부드럽습니다.',
    specs: ['하중: 5톤', '소재: SUS304', '베어링: 볼베어링', '무게: 8.5kg'],
    inStock: true,
    rating: 4.8,
    reviews: 22,
  },
  {
    id: 'p008',
    name: '중형 나일론 블록 (2톤)',
    category: 'deck-equipment',
    subcategory: 'Block',
    manufacturer: '보령해양기계',
    region: 'boryeong',
    price: 180000,
    unit: '개',
    image: 'https://readdy.ai/api/search-image?query=medium-nylon-pulley-block-2-ton-capacity-white-background-product-shot-durable-plastic-sheave-marine-rigging-hardware-lightweight-nautical-equipment-professional-quality&width=800&height=600&seq=prod008&orientation=landscape',
    description: '경량화된 나일론 소재의 중형 블록입니다. 부식 걱정 없이 사용 가능하며 가성비가 우수합니다.',
    specs: ['하중: 2톤', '소재: 강화 나일론', '베어링: 부시 타입', '무게: 1.2kg'],
    inStock: true,
    rating: 4.5,
    reviews: 35,
  },

  // 갑판용품 - Shackle
  {
    id: 'p009',
    name: '보우 샤클 (3톤급)',
    category: 'deck-equipment',
    subcategory: 'Shackle',
    manufacturer: '부산철강',
    region: 'busan',
    price: 45000,
    unit: '개',
    image: 'https://readdy.ai/api/search-image?query=bow-shackle-3-ton-capacity-stainless-steel-white-background-product-photography-u-shaped-marine-hardware-screw-pin-nautical-rigging-equipment-professional-grade-metal&width=800&height=600&seq=prod009&orientation=landscape',
    description: '3톤급 보우 샤클입니다. 스테인리스 소재로 부식에 강하며 다양한 연결 작업에 사용됩니다.',
    specs: ['하중: 3톤', '소재: SUS304', '핀 타입: 스크류', '무게: 0.8kg'],
    inStock: true,
    rating: 4.7,
    reviews: 56,
  },
  {
    id: 'p010',
    name: '디 샤클 (5톤급)',
    category: 'deck-equipment',
    subcategory: 'Shackle',
    manufacturer: '포항철강해양',
    region: 'pohang',
    price: 68000,
    unit: '개',
    image: 'https://readdy.ai/api/search-image?query=d-shackle-5-ton-capacity-galvanized-steel-white-background-product-shot-d-shaped-marine-hardware-bolt-pin-nautical-rigging-equipment-heavy-duty-industrial-grade&width=800&height=600&seq=prod010&orientation=landscape',
    description: '5톤급 D형 샤클입니다. 아연도금 처리로 내구성이 우수하며 대형 작업에 적합합니다.',
    specs: ['하중: 5톤', '소재: 아연도금강', '핀 타입: 볼트', '무게: 1.5kg'],
    inStock: true,
    rating: 4.8,
    reviews: 41,
  },

  // 기관물품 - 엔진 부품
  {
    id: 'p011',
    name: '디젤 엔진 피스톤 세트',
    category: 'engine-parts',
    subcategory: '엔진 부품',
    manufacturer: '부산해양엔진',
    region: 'busan',
    price: 1850000,
    unit: '세트',
    image: 'https://readdy.ai/api/search-image?query=diesel-engine-piston-set-marine-grade-white-background-product-photography-metal-cylinders-automotive-parts-professional-quality-industrial-components-clean-detailed&width=800&height=600&seq=prod011&orientation=landscape',
    description: '선박용 디젤 엔진 피스톤 세트입니다. 고품질 합금 소재로 제작되어 내구성이 뛰어납니다.',
    specs: ['적용: 6기통 디젤', '소재: 알루미늄 합금', '직경: 120mm', '세트 구성: 6개'],
    inStock: true,
    rating: 4.9,
    reviews: 15,
  },
  {
    id: 'p012',
    name: '터보차저 (중형 어선용)',
    category: 'engine-parts',
    subcategory: '엔진 부품',
    manufacturer: '여수해양엔진',
    region: 'yeosu',
    price: 4200000,
    unit: '개',
    image: 'https://readdy.ai/api/search-image?query=marine-turbocharger-medium-fishing-vessel-white-background-product-shot-metal-turbine-engine-component-professional-grade-industrial-equipment-detailed-mechanical-part&width=800&height=600&seq=prod012&orientation=landscape',
    description: '중형 어선용 고성능 터보차저입니다. 엔진 출력 향상과 연료 효율 개선에 효과적입니다.',
    specs: ['적용 마력: 300-500HP', '최대 RPM: 120,000', '소재: 내열 합금', '무게: 28kg'],
    inStock: true,
    rating: 4.7,
    reviews: 12,
  },

  // 기관물품 - 필터
  {
    id: 'p013',
    name: '연료 필터 (디젤용)',
    category: 'engine-parts',
    subcategory: '필터',
    manufacturer: '목포해양부품',
    region: 'mokpo',
    price: 85000,
    unit: '개',
    image: 'https://readdy.ai/api/search-image?query=diesel-fuel-filter-marine-engine-white-background-product-photography-cylindrical-metal-canister-automotive-part-professional-quality-clean-industrial-component&width=800&height=600&seq=prod013&orientation=landscape',
    description: '선박용 디젤 연료 필터입니다. 미세 불순물 제거로 엔진 수명을 연장시킵니다.',
    specs: ['여과 등급: 10μm', '유량: 200L/h', '소재: 스틸 케이스', '교체 주기: 500시간'],
    inStock: true,
    rating: 4.6,
    reviews: 48,
  },
  {
    id: 'p014',
    name: '오일 필터 (대형 엔진용)',
    category: 'engine-parts',
    subcategory: '필터',
    manufacturer: '통영해양부품',
    region: 'tongyeong',
    price: 120000,
    unit: '개',
    image: 'https://readdy.ai/api/search-image?query=large-engine-oil-filter-marine-heavy-duty-white-background-product-shot-cylindrical-metal-filter-automotive-component-professional-grade-industrial-quality&width=800&height=600&seq=prod014&orientation=landscape',
    description: '대형 선박 엔진용 오일 필터입니다. 고효율 여과 성능으로 엔진을 보호합니다.',
    specs: ['여과 등급: 25μm', '유량: 300L/h', '소재: 알루미늄', '교체 주기: 300시간'],
    inStock: true,
    rating: 4.8,
    reviews: 33,
  },

  // 기관물품 - 오일
  {
    id: 'p015',
    name: '선박용 엔진 오일 (15W-40)',
    category: 'engine-parts',
    subcategory: '오일',
    manufacturer: '부산해양유류',
    region: 'busan',
    price: 280000,
    unit: '200L',
    image: 'https://readdy.ai/api/search-image?query=marine-engine-oil-15w40-large-drum-barrel-200-liter-white-background-product-photography-blue-metal-container-industrial-lubricant-professional-quality&width=800&height=600&seq=prod015&orientation=landscape',
    description: '고품질 선박용 디젤 엔진 오일입니다. 우수한 윤활 성능과 엔진 보호 기능을 제공합니다.',
    specs: ['점도: 15W-40', '용량: 200L', '규격: API CI-4', '적용: 4행정 디젤'],
    inStock: true,
    rating: 4.9,
    reviews: 67,
  },
  {
    id: 'p016',
    name: '기어 오일 (SAE 90)',
    category: 'engine-parts',
    subcategory: '오일',
    manufacturer: '포항해양유류',
    region: 'pohang',
    price: 180000,
    unit: '200L',
    image: 'https://readdy.ai/api/search-image?query=marine-gear-oil-sae-90-drum-barrel-200-liter-white-background-product-shot-red-metal-container-industrial-lubricant-professional-grade-transmission-oil&width=800&height=600&seq=prod016&orientation=landscape',
    description: '선박 감속기 및 기어박스용 오일입니다. 고하중 조건에서도 안정적인 성능을 발휘합니다.',
    specs: ['점도: SAE 90', '용량: 200L', '규격: API GL-4', '적용: 기어박스'],
    inStock: true,
    rating: 4.7,
    reviews: 44,
  },

  // 어구류 - 부표
  {
    id: 'p017',
    name: '대형 PE 부표 (직경 60cm)',
    category: 'fishing-gear',
    subcategory: '부표',
    manufacturer: '제주해양자재',
    region: 'jeju',
    price: 95000,
    unit: '개',
    image: 'https://readdy.ai/api/search-image?query=large-polyethylene-fishing-buoy-60cm-diameter-orange-color-white-background-product-photography-spherical-float-marine-equipment-professional-quality-durable-plastic&width=800&height=600&seq=prod017&orientation=landscape',
    description: '내구성이 뛰어난 대형 PE 부표입니다. 시인성이 좋은 주황색으로 제작되었습니다.',
    specs: ['직경: 60cm', '소재: PE', '부력: 80kg', '색상: 주황'],
    inStock: true,
    rating: 4.6,
    reviews: 28,
  },
  {
    id: 'p018',
    name: '소형 발포 부표 (직경 30cm)',
    category: 'fishing-gear',
    subcategory: '부표',
    manufacturer: '목포수산자재',
    region: 'mokpo',
    price: 28000,
    unit: '개',
    image: 'https://readdy.ai/api/search-image?query=small-foam-fishing-buoy-30cm-diameter-yellow-color-white-background-product-shot-spherical-float-lightweight-marine-equipment-professional-grade&width=800&height=600&seq=prod018&orientation=landscape',
    description: '경량 발포 소재의 소형 부표입니다. 자망 및 연승 어업에 적합합니다.',
    specs: ['직경: 30cm', '소재: 발포 폼', '부력: 15kg', '색상: 노랑'],
    inStock: true,
    rating: 4.5,
    reviews: 52,
  },

  // 갑판용품 - 체인
  {
    id: 'p019',
    name: '아연도금 체인 (12mm)',
    category: 'deck-equipment',
    subcategory: '체인',
    manufacturer: '부산철강',
    region: 'busan',
    price: 150000,
    unit: '10m',
    image: 'https://readdy.ai/api/search-image?query=galvanized-steel-chain-12mm-thick-links-white-background-product-photography-zinc-coated-metal-heavy-duty-marine-hardware-industrial-quality-shiny-silver&width=800&height=600&seq=prod019&orientation=landscape',
    description: '12mm 아연도금 체인입니다. 계선 및 고정 작업에 사용되며 부식에 강합니다.',
    specs: ['링크 직경: 12mm', '길이: 10m', '파단하중: 5,000kg', '소재: 아연도금강'],
    inStock: true,
    rating: 4.7,
    reviews: 39,
  },
  {
    id: 'p020',
    name: '스테인리스 체인 (8mm)',
    category: 'deck-equipment',
    subcategory: '체인',
    manufacturer: '포항철강해양',
    region: 'pohang',
    price: 220000,
    unit: '10m',
    image: 'https://readdy.ai/api/search-image?query=stainless-steel-chain-8mm-links-white-background-product-shot-corrosion-resistant-metal-marine-hardware-professional-grade-shiny-polished-nautical-equipment&width=800&height=600&seq=prod020&orientation=landscape',
    description: '8mm 스테인리스 체인입니다. 고급 소재로 장기간 사용 가능하며 미관이 우수합니다.',
    specs: ['링크 직경: 8mm', '길이: 10m', '파단하중: 2,500kg', '소재: SUS316'],
    inStock: true,
    rating: 4.8,
    reviews: 26,
  },

  // 기관물품 - 냉각 시스템
  {
    id: 'p021',
    name: '해수 냉각 펌프',
    category: 'engine-parts',
    subcategory: '냉각 시스템',
    manufacturer: '여수해양엔진',
    region: 'yeosu',
    price: 850000,
    unit: '개',
    image: 'https://readdy.ai/api/search-image?query=marine-seawater-cooling-pump-white-background-product-photography-metal-pump-housing-engine-component-professional-quality-industrial-equipment-nautical-machinery&width=800&height=600&seq=prod021&orientation=landscape',
    description: '선박 엔진용 해수 냉각 펌프입니다. 내식성이 우수한 소재로 제작되었습니다.',
    specs: ['유량: 150L/min', '양정: 15m', '소재: 청동', '전원: 24V DC'],
    inStock: true,
    rating: 4.7,
    reviews: 19,
  },
  {
    id: 'p022',
    name: '열교환기 (판형)',
    category: 'engine-parts',
    subcategory: '냉각 시스템',
    manufacturer: '부산해양엔진',
    region: 'busan',
    price: 1200000,
    unit: '개',
    image: 'https://readdy.ai/api/search-image?query=plate-heat-exchanger-marine-engine-white-background-product-shot-stainless-steel-plates-cooling-system-component-professional-grade-industrial-equipment&width=800&height=600&seq=prod022&orientation=landscape',
    description: '고효율 판형 열교환기입니다. 컴팩트한 설계로 공간 활용이 우수합니다.',
    specs: ['용량: 50kW', '판 수: 30매', '소재: SUS316', '무게: 35kg'],
    inStock: true,
    rating: 4.8,
    reviews: 14,
  },

  // 기관물품 - 전기 부품
  {
    id: 'p023',
    name: '선박용 발전기 (10kW)',
    category: 'engine-parts',
    subcategory: '전기 부품',
    manufacturer: '통영해양전기',
    region: 'tongyeong',
    price: 3800000,
    unit: '대',
    image: 'https://readdy.ai/api/search-image?query=marine-generator-10kw-white-background-product-photography-compact-power-unit-nautical-electrical-equipment-professional-quality-industrial-machinery-metal-housing&width=800&height=600&seq=prod023&orientation=landscape',
    description: '10kW 선박용 발전기입니다. 안정적인 전력 공급으로 선내 전기 설비를 운영합니다.',
    specs: ['출력: 10kW', '전압: 220V/380V', '연료: 디젤', '무게: 180kg'],
    inStock: true,
    rating: 4.9,
    reviews: 11,
  },
  {
    id: 'p024',
    name: '배터리 충전기 (100A)',
    category: 'engine-parts',
    subcategory: '전기 부품',
    manufacturer: '부산해양전기',
    region: 'busan',
    price: 680000,
    unit: '대',
    image: 'https://readdy.ai/api/search-image?query=marine-battery-charger-100-amp-white-background-product-shot-metal-case-electrical-equipment-professional-grade-nautical-power-supply-industrial-quality&width=800&height=600&seq=prod024&orientation=landscape',
    description: '대용량 배터리 충전기입니다. 다중 배터리 뱅크 충전이 가능하며 과충전 방지 기능이 있습니다.',
    specs: ['출력: 100A', '입력: 220V AC', '출력: 12V/24V DC', '무게: 15kg'],
    inStock: true,
    rating: 4.6,
    reviews: 27,
  },
];